"use client"

import { createContext, useState } from "react";

export const UserContext = createContext<any>(null);

const UserProvider = ({ children }: { children: React.ReactNode }) => {

    const [ userData, setUserData ] = useState<any>(null);

    return (
        <UserContext.Provider value={{ userData, setUserData }}>
            {children}
        </UserContext.Provider>
    )
}

export default UserProvider;